import React from "react";
import '../styles/cart.css';
import { Tabs, TabList, TabPanels, Tab, TabPanel,Text,Box, Flex,Button,useDisclosure } from '@chakra-ui/react'
import { Textarea } from '@chakra-ui/react'
import { Divider } from '@chakra-ui/react'
import ImageUploader from "./ImageUploader";
import InterestBadge from "./ui/Interestbadge";
import { useTranslation } from "react-i18next";
const Onboarding = () => {
    const { t } = useTranslation();

    return (
        <>
        <Box backgroundColor={'white'} borderRadius={10} padding={5} width='100%' height='100vh'
                            justifyContent='center'
                            margin='20px'
                            >
                        <Flex justifyContent='space-between ' width='700px' borderBottom='1px' borderColor={'gray.200'}>
                            <Box>
                            <Text mb={0}  fontSize={22}>{t("onboarding.profileDetails")}</Text>
                            <Text mb={3} color={'gray.500'} fontSize={'12px'} >{t("onboarding.profileDetailsHint")}</Text>
                        </Box>
                        <Flex gap="10px">
                            <Button color={'white'} size={'sm'} backgroundColor={'black'}>{t("onboarding.continue")}</Button>
                        </Flex>
                        </Flex>
                        <Flex pb={5} gap={20} mt={'20px'} mb={'20px'} justifyContent='space-between ' width='700px' borderBottom='1px' borderColor={'gray.200'}>
                            <Box >
                            <Text mb={0}  fontSize={16}>{t("onboarding.editBio")}</Text>
                            <Text fontSize={12} >{t("onboarding.editBioHint")}</Text>
                        </Box>
                        <Flex gap="10px">
                            <Textarea width={'350px'} placeholder={t("onboarding.bioPlaceholder")} />
                        </Flex>
                        </Flex>
                        <Flex pb={5} gap={20} mt={'20px'} justifyContent='space-between ' width='700px' >
                            <Box >
                            <Text mb={0}  fontSize={16}>{t("onboarding.imagesTitle")}</Text>
                            <Text fontSize={12} >{t("onboarding.imagesHint")}</Text>
                        </Box>
                        </Flex>
                        <ImageUploader />
                        <Divider/>
                        <Flex pb={5} gap={20} mt={'20px'} mb={'20px'} justifyContent='space-between ' width='700px'>
                            <Box >
                            <Text mb={0}  fontSize={16}>{t("onboarding.interestsTitle")}</Text>
                            <Text fontSize={12} >{t("onboarding.interestsHint")}</Text>
                        </Box>
                        </Flex>
                        <Flex>
                            <InterestBadge/>
                        </Flex>
                        </Box>
        </>
     );
}
 
export default Onboarding;